<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-17 09:43:31
 * @LastEditTime: 2019-09-20 13:29:00
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_container">
        <div class="page">
            <div id="main-container" class="main-container">
                <div class="successInfo">
                    <div class="img"><img src="../assets/img/common/Shape@2x.png" alt=""> </div>
                    <div class="title">恭喜您加入合伙人</div>
                    <div class="button" @click="toGoodList">马上去赚钱</div>

                </div>
                <div class="morePro"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        toGoodList() {
            this.esvOpenPage({ name: 'OPGoodlist', params: { retailStoreProductFlag: 1 } });
        }
    }
};
</script>

<style lang="scss">
    #page_container {
        background-color: #fff;
        height: 100%;
        .successInfo {
            padding-top: 30px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            flex-direction: column;
            .img {
                margin-bottom: 16px;
                img {
                    width: 65px;
                    height: 65px;
                }
                // background: url('../../assets/img/common/Shape@2x.png') no-repeat center;
                // background-size: cover;
                // width: 65px;
                // height: 65px;
            }
            .title {
                font-size: 20px;
                color: #333333;
                margin-bottom: 30px;
            }
            .button {
                width: calc(100% - 48px);
                height: 44px;
                margin: 0 24px;
                background: #EE2E50;
                color: #fff;
                text-align: center;
                line-height: 44px;
                border-radius: 22px;
            }
        }
        .morePro {}
    }
</style>
